module.exports = __webpack_public_path__ + "media/images/illustrations/marker_with_route_small-6420e8d342b5bc272a4ef8ed7078a144.svg";